import styled from "styled-components"

export const DefaultContainer = styled.div`
   width: min(100% - 3rem, 77rem);
   margin-inline: auto;
`
